import { Route, HashRouter as Router, Switch } from 'react-router-dom';
import { NotificationContainer } from './components/common/react-notifications';
import { LayoutContextProvider } from './context/LayoutContext';
import { UserContextProvider } from './context/UserContext';
import { ViewApp } from './views/ViewApp';

function App() {
  return (
    <Router>
      <LayoutContextProvider>
        <UserContextProvider>
            <NotificationContainer />
            <ViewApp />
        </UserContextProvider>
      </LayoutContextProvider>
    </Router>
  );
}

export default App;
